import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ItemChangeSummary, ChangeType } from '../../factories/item-history.factory';
import { saveAs } from 'file-saver';
import * as moment from 'moment';

@Component({
  selector: 'app-item-history',
  templateUrl: './item-history.component.html',
  styleUrls: ['./item-history.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ItemHistoryComponent implements OnInit {
  @Input() changes: ItemChangeSummary[] = [];
  displayedColumns: string[] = ['field', 'oldValue', 'newValue'];

  ngOnInit() {
    this.changes.sort((a, b) => 
      moment(b.changeDate).valueOf() - moment(a.changeDate).valueOf()
    );
  }

  formatDate(date: string): string {
    return moment(date).format('MMM D, YYYY h:mm A');
  }

  getChangeTypeClass(changeType: ChangeType): string {
    const classMap = {
      [ChangeType.Location]: 'location-change',
      [ChangeType.Assignment]: 'assignment-change',
      [ChangeType.Status]: 'status-change',
      [ChangeType.Properties]: 'properties-change',
      [ChangeType.Identification]: 'identification-change'
    };
    return classMap[changeType] || 'default-change';
  }

  getChangeTypeIconClass(changeType: ChangeType): string {
    const iconMap = {
      [ChangeType.Location]: 'fa-map-marker-alt',
      [ChangeType.Assignment]: 'fa-user-edit',
      [ChangeType.Status]: 'fa-info-circle',
      [ChangeType.Properties]: 'fa-cog',
      [ChangeType.Identification]: 'fa-id-card'
    };
    return iconMap[changeType] || 'fa-history';
  }

  generateAuditReport() {
    const reportContent = this.generateAuditReportContent();
    const blob = new Blob([reportContent], { type: 'text/plain;charset=utf-8' });
    const filename = `item-audit-report-${moment().format('YYYY-MM-DD-HHmmss')}.txt`;
    saveAs(blob, filename);
  }

  private generateAuditReportContent(): string {
    let report = 'ITEM AUDIT REPORT\n';
    report += `Generated: ${moment().format('MMMM D, YYYY HH:mm:ss')}\n\n`;

    if (this.changes.length > 0) {
      report += `Item: ${this.changes[0].itemIdentifier} - ${this.changes[0].itemDescription}\n`;
      report += '='.repeat(80) + '\n\n';
    }

    this.changes.forEach((change, index) => {
      report += `CHANGE #${this.changes.length - index}\n`;
      report += '-'.repeat(80) + '\n';
      report += `Type: ${change.changeType}\n`;
      report += `Date: ${moment(change.changeDate).format('MMMM D, YYYY HH:mm:ss')}\n`;
      report += `Changed By: ${change.changedBy}\n\n`;

      report += 'CHANGES\n';
      report += '-'.repeat(20) + '\n';
      change.changes.forEach(itemChange => {
        report += `${itemChange.field}:\n`;
        report += `  From: ${itemChange.oldValue}\n`;
        report += `  To:   ${itemChange.newValue}\n`;
      });
      report += '\n' + '='.repeat(80) + '\n\n';
    });

    return report;
  }
} 